import { Modal, message as $message } from 'antd'
import { ERP_SUPPLIER_KEY } from '@/modules/goods/constants/goodsSourceType'
import { GOODS_SHELF } from '@/modules/goods/constants/materialActions'
import {
    queryFolderIdStyleCode,
    goodsBindFolder,
    querySpuIdBySupplierSpuId,
    querySupplierFolderIdStyleCode
} from '@/services/cloudDisk'

import { getStore } from '@/utils/dva'
import { jstLogEvent } from '@/utils/logger'

const log = () => {
    const text = '应用素材空间图片'

    jstLogEvent({
        element: 'apply_material_space_image',
        args: {
            text
        }
    })
}

/*
 * 从素材库选择文件
 * 上传、富文本公用
 * */

export default async ({ cloudDiskFolderId, disMaterialLib, multiple, accept, form, onChange }) => {
    const $store = getStore() || {}
    const state = ($store.getState && $store.getState()) || {}

    // 素材库上传需要spuId
    let spuId = null
    if (disMaterialLib) {
        spuId = state?.modal?.materialImagesProps?.spuId
    }

    let baseDataId = ''
    let supplierMaterialDir = null

    const localData = form?._localData || {}

    const { itemCoId, formType, shelvesPattern, goodsSource } = localData

    const isBaseGoods = form?.__INTERNAL__?.name === 'base'

    const currentUser = state?.currentUser || {}
    // 分销商品
    const isDistributeGoods = currentUser.coId !== itemCoId
    // 是否铺货
    // shelvesPattern
    // goodsSource && goodsSource === ERP_SUPPLIER_KEY erp商品
    const isSingleShelf = formType === 'create' && !isBaseGoods && !shelvesPattern && goodsSource !== ERP_SUPPLIER_KEY

    const doDispach = data => {
        const { dispatch } = $store
        const { id, spuId: itemSpuId } = data || {}

        // 基础资料直接从表单读取款式编码和关联的素材，省事

        const styleCode = (isBaseGoods && form?.getFieldValue('styleCode')) || ''
        const matchedFolder = (isBaseGoods && form?.getFieldValue('matchedFolder')) || {}
        const { cloudDiskFolderId: newCloudDiskFolderId } = matchedFolder
        const { bindMaterialDir } = form || {}

        console.info('doDispach:', {
            id: newCloudDiskFolderId || id,
            spuId: itemSpuId,
            spuId2: spuId,
            baseDataId,
            styleCode,
            enableOutStyleCode: isBaseGoods,
            itemCoId,
            action: isSingleShelf ? GOODS_SHELF : '',
            supplierMaterialDir,
            multiple,
            accept,
            shelvesPattern,
            goodsSource
        })

        dispatch({
            type: 'modal/updateMaterialImagesProps',
            payload: {
                dataSource: {
                    id: newCloudDiskFolderId || id,
                    spuId: itemSpuId,
                    baseDataId,
                    styleCode,
                    enableOutStyleCode: isBaseGoods,
                    itemCoId,
                    action: isSingleShelf ? GOODS_SHELF : '',
                    supplierMaterialDir,
                    multiple,
                    accept
                },
                onBind: bindMaterialDir,
                onOk: (v, recommendFile) => {
                    dispatch({
                        type: 'modal/updateMaterialImagesProps',
                        payload: {
                            visible: false,
                            dataSource: null
                        }
                    })

                    log()
                    onChange && onChange(v)

                    if (recommendFile) {
                        Modal.confirm({
                            icon: false,
                            title: '',
                            content: `是否要将素材包【${recommendFile?.fileName}】关联到当前商品上？关联后运营秒换商品资料图，1秒上架全网。`,
                            onOk: async () => {
                                if (isBaseGoods) {
                                    // 基础资料关联
                                    bindMaterialDir([recommendFile])
                                } else {
                                    // 上架页面直接调用接口关联
                                    const { success, message } = await goodsBindFolder([
                                        {
                                            cloudDiskFolderId: recommendFile.id,
                                            spuId: isDistributeGoods && isSingleShelf ? baseDataId : spuId
                                        }
                                    ])

                                    if (success) {
                                        $message.success('关联成功')
                                    } else {
                                        $message.error(message)
                                    }
                                }
                            },
                            onCancel: () => {},
                            okText: '确定',
                            okButtonProps: {
                                'data-log-text': '素材推荐关联-确定'
                            },
                            cancelText: '取消',
                            cancelButtonProps: {
                                'data-log-text': '素材推荐关联-取消'
                            }
                        })
                    }
                },
                visible: true,
                onCancel() {
                    dispatch({
                        type: 'modal/updateMaterialImagesProps',
                        payload: {
                            visible: false,
                            dataSource: null
                        }
                    })
                }
            }
        })
    }

    // 如果没有spuId与cloudDiskFolderId。直接选择图片
    if (!cloudDiskFolderId && !spuId) {
        return doDispach()
    }

    // 在上架与编辑页面直接使用， 或直接传入 cloudDiskFolderId。
    const dataSource = {
        multiple,
        spuId,
        accept
    }

    if (cloudDiskFolderId) {
        Object.assign(dataSource, {
            cloudDiskFolderId
        })
    }

    if (spuId) {
        if (isDistributeGoods && isSingleShelf) {
            const [baseRes, supplierRes] = await Promise.all([
                querySpuIdBySupplierSpuId({
                    itemCoId,
                    spuId
                }),
                querySupplierFolderIdStyleCode({
                    itemCoId,
                    spuId
                })
            ])

            if (baseRes.success) {
                baseDataId = baseRes.data || ''
            }
            if (supplierRes.success) {
                supplierMaterialDir = supplierRes.data?.cloudDiskFolderId ? supplierRes.data : null
            }

            if (baseDataId) {
                const { success, message, data } = await queryFolderIdStyleCode({ spuId: baseDataId })

                if (success) {
                    if (data?.cloudDiskFolderId) {
                        Object.assign(dataSource, {
                            cloudDiskFolderId: data?.cloudDiskFolderId,
                            ...data
                        })
                    } else {
                        return doDispach()
                    }
                } else {
                    $message.error(message)
                }
            }
        } else {
            const { success, message, data } = await queryFolderIdStyleCode({ spuId })

            if (success) {
                if (data?.cloudDiskFolderId) {
                    Object.assign(dataSource, {
                        cloudDiskFolderId: data?.cloudDiskFolderId,
                        ...data
                    })
                } else {
                    return doDispach()
                }
            } else {
                $message.error(message)
            }
        }
    }

    doDispach({
        id: dataSource?.cloudDiskFolderId,
        spuId
    })
}
